import { createSelector } from 'reselect';
import { RegionDto } from '@trucktrax/trucktrax-ts-common';
import { ReduxState } from '..';
import { MapMarker } from '../../types';
import { determineMapMarkerId } from '../../util/markerUtil';

export type OpenMapMarker = MapMarker & {
  timestamp: number | null;
};

const sortedOpenMarkers = (state: Partial<ReduxState>): OpenMapMarker[] => {
  const { currentRegion, selectedProductLine, activeMarkers } = state;
  const hasNoRegion = !currentRegion || !currentRegion?.url;
  const hasNoProductLine = !selectedProductLine;
  const region = currentRegion as unknown as RegionDto;
  const emptyPopupToggleMap = !state.popupToggleMap || !state.popupToggleMap.region?.[region?.id];
  const shouldBailOut = hasNoRegion || hasNoProductLine || emptyPopupToggleMap || !region;
  if (shouldBailOut) {
    return [];
  }
  const currentPopupMap = state.popupToggleMap!;
  const regionMap = currentPopupMap.region![region.id];
  const productLineMap = { ...regionMap[selectedProductLine] };

  const ids = Object.keys(productLineMap).filter(key => Number.isInteger(parseInt(key, 10)));
  const openMarkers: OpenMapMarker[] = [];
  ids.forEach(id => {
    if (productLineMap[id].isOpen && !!productLineMap[id].timestamp) {
      const match = activeMarkers?.find((marker: unknown) => id === determineMapMarkerId(marker));
      const marker: OpenMapMarker = {
        id,
        markerId: id,
        timestamp: productLineMap[id].timestamp,
        ...match,
      };
      openMarkers.push(marker);
    }
  });

  openMarkers.sort((a, b) => (b.timestamp ?? 0) - (a.timestamp ?? 0));
  return openMarkers;
};

export const sortedOpenMarkersMatchingMapFilter = createSelector(
  [sortedOpenMarkers],
  (sortedOpenMarkers: OpenMapMarker[]): OpenMapMarker[] => sortedOpenMarkers,
);
